import resources from './resources';

export const config = {
  interpolation: { escapeValue: false }, 
  lng: 'es',
  resources,
};

export { resources };
